<header class="top-bar">
  <img src="transit-time-logo.svg" alt="" class="top-bar__logo" aria-hidden="true"/>
  <div class="top-bar__title">{{name}}</div>
  <div class="top-bar__spacer"></div>
  <div class="top-bar__user">
    <span *ngIf="userAlias">
      Welcome <a href="https://phonetool.amazon.com/users/{{userAlias}}">{{userAlias}}</a>
    </span>
  </div>
</header>

<aside>
  <app-navigation [pages]="pages"></app-navigation>
</aside>

<router-outlet></router-outlet>
